import { NgModule } from '@angular/core';
import { DopTableComponent } from './dop-table.component';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { ContextMenuModule } from 'primeng/contextmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CustomPaginatorDirective } from './directives/custom-paginator.directive';
import { ButtonModule } from 'primeng/button';
import { ClearInputDirective } from './directives/clear-input-directive';
import { CalendarModule } from 'primeng/calendar';
import { ThreeDigitDecimalNumberDirective } from './directives/decimal-input-directive';
import { IntegerInputDirective } from './directives/input-integer.directive';
import { AlphaNumericInputDirective } from './directives/alphanumeric-input.directive';
import { TooltipModule } from 'primeng/tooltip';

@NgModule({
  declarations: [
    DopTableComponent,
    CustomPaginatorDirective,
    ClearInputDirective,
    ThreeDigitDecimalNumberDirective,
    IntegerInputDirective,
    AlphaNumericInputDirective
  ],
  imports: [
    TableModule,
    CommonModule,
    ContextMenuModule,
    PaginatorModule,
    AutoCompleteModule,
    ButtonModule,
    CalendarModule,
    TooltipModule
  ],
  exports: [
    DopTableComponent
  ]
})
export class DopTableModule { }
